// @ vendors
const get = require('lodash/object/get');
const trim = require('lodash/string/trim');
// @ commons
const { APIGet, APIPost } = require('utilities/APIRequestHelper');
const apiURLBuilder = require('core/apiURLBuilder');
// @ helpers
const { getAccountByImposition } = require('utilities/currentAccountsHelper.js');
// @ constants
const actionTypes = require('constants/actionTypes');
const { COMBINED_DEPOSIT, EURO_TEXT } = require('constants/index');

const resetFetchedImpositions = () => ({
  type: actionTypes.RESET_FETCHED_IMPOSITIONS,
});

const requestImpositionsInProgress = id => ({
  type: actionTypes.FETCH_IMPOSITIONS_REQUEST,
  payload: { id },
});

const requestImpositionsSuccess = (response, id, borderDates, closestExpirationDate) => {
  return {
    type: actionTypes.FETCH_IMPOSITIONS_SUCCESS,
    payload: {
      actualDate: response.fechaActual || '',
      impositionAssociatedAccount: {
        product: get(response, 'cuentasociada.producto', ''),
        contractNumber: get(response, 'cuentasociada.numerodecontrato', ''),
      },
      impositionList: get(response, 'listaImposiciones.filas', []),
      id,
      borderDates,
      closestExpirationDate,
      depositStandard: response.depositStandard,
      depositSubType: response.reposicionamiento.idstipro,
      depositType: response.subtipo,
      country: response.codmon02,
      currency: response.codmon01
    },
  }
};

const requestImpositionsFailure = error => ({
  type: actionTypes.FETCH_IMPOSITIONS_FAILURE,
  payload: {
    error: error,
  },
});

const requestImpositionsCompleted = () => ({
  type: actionTypes.FETCH_IMPOSITIONS_COMPLETED,
});

const updateDepositsSuccess = data => ({
  type: actionTypes.UPDATE_DEPOSITS,
  payload: {
    deposits: data,
  },
});

const requestCombinedDepositsSuccess = (response, depositId, impositionId) => {
  const productsCombinedList = get(response, 'listadoProductosCombinados.lista[0]', []);
  const fundContractNumber = productsCombinedList.contratoFondo.numerodecontrato;

  return {
    type: actionTypes.FETCH_COMBINED_DEPOSITS_SUCCESS,
    payload: {
      id: depositId,
      impositionId: impositionId,
      fund: trim(response.descc),
      fundContractNumber,
    },
  };
};

const requestCombinedDepositsFailure = error => ({
  type: actionTypes.FETCH_COMBINED_DEPOSITS_FAILURE,
  payload: {
    error,
  },
});

const requestCombinedDepositsDetailSuccess = (response, depositId, impositionId) => ({
  type: actionTypes.FETCH_COMBINED_DEPOSITS_DETAIL_SUCCESS,
  payload: {
    id: depositId,
    impositionId: impositionId,
    fundsAmount: {
      amount: response.valorLiquidFondo || 0,
      currency: response.monedaFondo || EURO_TEXT,
    },
    fundParticipations: response.numeroParticipaciones || 0,
  },
});

const requestCombinedDepositsDetailFailure = error => ({
  type: actionTypes.FETCH_COMBINED_DEPOSITS_DETAIL_FAILURE,
  payload: {
    error,
  },
});

const requestInterveners = depositId => ({
  type: actionTypes.FETCH_DEPOSIT_INTERVENERS_REQUEST,
  payload: {
    depositId,
  },
});

const requestDepositIntervenersSuccess = (response, depositId) => ({
  type: actionTypes.FETCH_DEPOSIT_INTERVENERS_SUCCESS,
  payload: {
    depositId,
    intervenersList: get(response, 'datosSalidas.dato', []),
  },
});

const requestDepositIntervenersFailure = (error, depositId) => ({
  type: actionTypes.FETCH_DEPOSIT_INTERVENERS_FAILURE,
  payload: {
    depositId,
    error,
  },
});

const updateRetentionRequestedDeposits = (data) => ({
  type: actionTypes.UPDATE_RETENTION_REQUESTED_DEPOSITS,
  payload: { data },
});

const hideDepositOfferPostRequest = () => ({
  type: actionTypes.HIDE_DEPOSIT_OFFER_POST_REQUEST,
});

const hideDepositOfferPostSuccess = () => ({
  type: actionTypes.HIDE_DEPOSIT_OFFER_POST_SUCCESS,
});

const hideDepositOfferPostFailed = () => ({
  type: actionTypes.HIDE_DEPOSIT_OFFER_POST_FAILED,
});

const hideDepositOfferPostReset = () => ({
  type: actionTypes.HIDE_DEPOSIT_OFFER_POST_RESET
})

const requestCombinedDepositsDetail = (response, immDeposit, impositionContractId) => dispatch => {
  const contractNumber = immDeposit.get('contractNumber');
  const product = immDeposit.get('product');
  const depositId = immDeposit.get('id');
  const productsCombinedList = get(response, 'listadoProductosCombinados.lista[0]', []);
  const fundContractNumber = get(productsCombinedList, 'contratoFondo.numerodecontrato', '');
  const fundProduct = get(productsCombinedList, 'contratoFondo.producto', '');
  const participationNumber = productsCombinedList.numeroParticipaciones || 0;
  const situationDate = productsCombinedList.fechaSituacion;
  const startDate = productsCombinedList.fechaInicio;
  const fundCode = get(response, 'codFondo', '');
  const fundLiteralDescriptionPlan = get(response, 'literalDescripFondoPlan', '');
  const operationalSituation = get(response, 'situOpera', '');

  const requestData = {
    query: {
      codFondo: fundCode,
      producto: product,
      numeroContrato: contractNumber,
      productoFondo: fundProduct,
      numeroContratoFondo: fundContractNumber,
      fechaInicio: startDate,
      fechaSituacion: situationDate,
      literalDescripFondoPlan: fundLiteralDescriptionPlan,
      numeroIpf: impositionContractId,
      numeroParticipaciones: participationNumber,
      situacionOperativa: operationalSituation,
    },
  };

  return APIGet(dispatch, apiURLBuilder.getURL('requestCombinedDepositsDetail'), requestData)
    .then(response =>
      dispatch(
        requestCombinedDepositsDetailSuccess(response, depositId, impositionContractId),
      ),
    )
    .catch(response => dispatch(requestCombinedDepositsDetailFailure(response.error)));
};

const requestCombinedDeposits = (response, immDeposit, immAccounts) => dispatch => {
  const subTypeProduct = immDeposit.get('subTypeProduct');
  const impositionList = get(response, 'listaImposiciones.filas', []);

  if (subTypeProduct === COMBINED_DEPOSIT && impositionList.length) {
    const contractNumber = immDeposit.get('contractNumber');
    const product = immDeposit.get('product');
    const depositId = immDeposit.get('id');
    const currency = response.codmon01 || EURO_TEXT;
    const impositionAssociatedAccount = response.cuentasociada;
    const fundContractNumber = impositionAssociatedAccount.numerodecontrato;
    const immAssociatedAccount = getAccountByImposition(
      impositionAssociatedAccount,
      immAccounts,
    );
    const controlDigit = immAssociatedAccount.getIn(['ibanComplex', 'digitodecontrol']);
    const accountNumber = `${immAssociatedAccount.get('product')}${immAssociatedAccount.get(
      'contractNumber',
    )}`;
    const amount = immDeposit.getIn(['totalAvailableBalance', 'amount']);

    impositionList.forEach(imposition => {
      const impositionContractId = imposition.idscontr;
      const requestData = {
        query: {
          producto: product,
          numeroContrato: contractNumber,
          fechaVencimiento: imposition.fecvenci,
          digitoControl: controlDigit,
          numeroCuenta: accountNumber,
          divisa: currency,
          numeroIpf: impositionContractId,
          operacion: 'L', // @harcoded
          numeroContratoFondo: fundContractNumber,
          importe: amount,
        },
      };

      return APIGet(dispatch, apiURLBuilder.getURL('requestCombinedDeposits'), requestData)
        .then(response => {
          dispatch(
            requestCombinedDepositsSuccess(response, depositId, impositionContractId),
          );
          dispatch(
            requestCombinedDepositsDetail(response, immDeposit, impositionContractId),
          );
        })
        .catch(response => dispatch(requestCombinedDepositsFailure(response.error)));
    });
  }
};

const getBorderDates = response => {
  const impositionsList = get(response, 'listaImposiciones.filas', []);
  let startDate = '';
  let endDate = '';

  if (impositionsList.length) {
    startDate = impositionsList[0].fecini;
    endDate = impositionsList[0].fecvenci;

    impositionsList.forEach(imposition => {
      if (new Date(startDate) > new Date(imposition.fecini)) startDate = imposition.fecini;
      if (new Date(endDate) < new Date(imposition.fecvenci)) endDate = imposition.fecvenci;
    });
  }

  return {
    startDate,
    endDate,
  };
};

const requestDeposits = (version = 2) => (dispatch, getState) => {
  let promises = [];
  const immDeposits = getState().deposits;
  const isAlreadyFetching = immDeposits.get('isFetching');
  const hasError = !!immDeposits.get('error');

  if (!isAlreadyFetching && (!hasError || hasError !== '')) {
    const immGlobalPositionDeposits = getState().globalPosition.getIn(['savings', 'allSavings']);
    const immAccounts = getState().accounts;
    dispatch(updateDepositsSuccess(immGlobalPositionDeposits));

    immGlobalPositionDeposits.forEach(immDeposit => {
      const requestData = {
        header: {
          version: version,
        },
        query: {
          operacion: 'L', //@hardcoded
          numeroContrato: immDeposit.get('contractNumber'),
          producto: immDeposit.get('product'),
          ...(__CONTACT_CENTER__ ? {
            feccon: '2016-11-24', //@hardcoded
            idstipro: immDeposit.get('subTypeProduct'),
            allPages: true,
          } : {}),
        },
      };

      dispatch(requestImpositionsInProgress(immDeposit.get('id')));

      promises.push(
        APIGet(dispatch, apiURLBuilder.getURL('impositions'), requestData)
          .then(response => {
            const closestExpirationDate = get(response, 'closestExpirationDate', undefined)
            dispatch(
              requestImpositionsSuccess(
                response,
                immDeposit.get('id'),
                getBorderDates(response),
                closestExpirationDate
              ),
            );
            dispatch(requestCombinedDeposits(response, immDeposit, immAccounts));
          })
          .catch(response => dispatch(requestImpositionsFailure(response.error))),
      );
    });
  }
  Promise.all(promises).then(() => dispatch(requestImpositionsCompleted()));
};

const requestDepositInterveners = depositId => (dispatch, getState) => {
  const immDeposit = getState().deposits.getIn(['byId', depositId]);
  const depositRequestData = {
    query: {
      numeroContrato: immDeposit.getIn(['contract', 'contractNumber']),
      paginando: 'N', //@hardcoded
      producto: immDeposit.getIn(['contract', 'product']),
    },
  };

  dispatch(requestInterveners(depositId));
  return APIGet({ dispatch, endpoint: 'depositInterveners', params: depositRequestData })
    .then(response =>
      dispatch(requestDepositIntervenersSuccess(response, depositId)),
    )
    .catch(response => {
      if (!!response.error) {
        dispatch(requestDepositIntervenersFailure(response, depositId));
      } else {
        throw response;
      }
    });
};

const requestRetentionDepositsData = (callback) => (dispatch) => {
  return APIGet({ dispatch, endpoint: 'retentionDeposits' }).then(response => {
    dispatch(updateRetentionRequestedDeposits(response));
    callback(response);
  });
};

const requestHideDepositOfferPost = (depositContractAndImpositionList) => (dispatch) => {
  dispatch(hideDepositOfferPostRequest())

  const requestData = {
    query: depositContractAndImpositionList
  };

  return APIPost(dispatch, apiURLBuilder.getURL('hideDepositRenewalPost'), requestData)
    .then(() => dispatch(hideDepositOfferPostSuccess()))
    .catch(() => {
      dispatch(hideDepositOfferPostFailed())
    });
}

const resetHideDepositOfferPost = () => dispatch => {
  dispatch(hideDepositOfferPostReset())
}

// We set back the Deposits reducer to its initial state in order to force a fetch with the new information
const resetDeposits = () => ({
  type: actionTypes.DEPOSITS_RESET,
});

module.exports = {
  requestDeposits,
  requestDepositInterveners,
  resetDeposits,
  requestRetentionDepositsData,
  resetFetchedImpositions,
  requestHideDepositOfferPost,
  resetHideDepositOfferPost
};
